module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loadingimg"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/bao.png"),
      "width": "100"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0fb5b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Loading.vue
// module id = 259
// module chunks = 0